import Avatar from "react-avatar";
import trashcan from "../images/trash-can.png";
import { useState } from 'react';
import axios from 'axios';
import useCookie from "../hooks/useCookie";
import { useContext } from "react";
import { ColorContext } from "../context/ColorContext";

// The ArtworkMagnifier component allows the user to view a gallery artwork closer-up,
// as well as associated data like artist, studio where it was created, and prompt
// (if applicable).

// IMPORTANT: ArtworkMagnifier was designed to be used in concert with the Gallery
// component. See use in Profile.jsx

// Required props: 
// - selectedArtwork (HTML element)
// - closeArtwork (function)
function ArtworkMagnifier(props)
{
    const csrftoken = useCookie("csrftoken");

    const headers = {
        "X-CSRFToken": csrftoken,
    };

    const { blue, white } = useContext(ColorContext);

    // If set to true, user has started the process of deleting
    // an artwork, starting with confirming intent to delete
    const [deleting, setDeleting] = useState(false);

    // FRACTAL digital studios
    const studios = {
        "PIX_ART": "Pixel Art",
        "ALG_ART": "Algorithmic Art",
        "AI_ART": "AI Art"
    };
    
    // Show deletion confirmation popup
    const startDeletionProcess = () => {
        setDeleting(true);
    }

    // If user confirmed intent to delete artwork, delete from database
    // and remove image from gallery interface
    const confirmDeletion = () => {
        // Delete image from database
        let imageID = props.selectedArtwork.getAttribute("data-id");
        
        axios.delete('/api/images/' + imageID, { headers })
        .then((response) => {
            // Remove artwork from interface
            props.selectedArtwork.remove();
            // Close artwork magnifier - delete operation successful
            setDeleting(false);
            props.closeArtwork();
        }).catch((error) => {
            // TODO: Add error handling
        })
    }

    // Cancel deletion process
    const cancelDeletion = () => {
        setDeleting(false);
    }

    return (
        <div id="artwork-magnifier"> {/* Artwork Magnifier */}
            {deleting ? (
                <div id="confirm-deletion"> {/* Deletion Confirmation Popup */}
                    <div>
                        Are you sure you want to delete this artwork?
                        <div id="confirm-deletion-buttons">
                            <button onClick={confirmDeletion}>Yes</button>
                            <button onClick={cancelDeletion}>No</button>
                        </div>                        
                    </div>                    
                </div>
            ) : (null)}
            <div id="magnifier-panel"> {/* Artwork Magnifier Panel */}
                <div className="panel-header panel-header-x-out">
                    <h2>View Artwork</h2>
                    <button id="x-out" onClick={props.closeArtwork}>X</button>
                </div>
                <div id="artwork-content">
                    {/* Artwork image */}
                    <img id="artwork" src={props.selectedArtwork && props.selectedArtwork.src}/>
                    {/* Artwork "metadata" (artist, studio, prompt - if applicable) */}
                    <div id="about-and-options">
                        <div id="about-artwork">
                            <div id="artist-info">
                                <Avatar id="student-avatar" name={props.selectedArtwork.getAttribute("data-artist")} round={true} size="50" color={blue} fgColor={white} /> {/* Profile picture */}
                                <h3>{props.selectedArtwork.getAttribute("data-artist")} <br/></h3>
                            </div>
                            <p>
                                Created in <strong>{studios[props.selectedArtwork.getAttribute("data-studio")]} Studio</strong><br/>
                                on <strong>{props.selectedArtwork.getAttribute("data-timestamp")}</strong>
                                {/* Display AI Art prompt, if applicable */}
                                {props.selectedArtwork.getAttribute("data-studio") == "AI_ART" && <>with prompt <strong>"{props.selectedArtwork.getAttribute("data-prompt")}"</strong></>}
                                {/* Display Pixel Art coloring sheet, if applicable */}
                                {props.selectedArtwork.getAttribute("data-studio") == "PIX_ART" 
                                    && props.selectedArtwork.getAttribute("data-prompt") != "No coloring sheet" ? 
                                        (<>with coloring sheet <strong>"{props.selectedArtwork.getAttribute("data-prompt")}"</strong></>) 
                                : null}
                            </p>
                        </div>
                        {/* Delete artwork button */}
                        <button id="delete-button" onClick={startDeletionProcess}>
                            <img id="trash-can" src={trashcan} /> {/* Trash Can */}
                            Delete
                        </button>
                    </div>
                </div>   
            </div>                                 
        </div>
    )
}

export default ArtworkMagnifier;